import { render } from "./sendToTeamsPopup.vue?vue&type=template&id=2852fb2b&scoped=true"
import script from "./sendToTeamsPopup.vue?vue&type=script&lang=js"
export * from "./sendToTeamsPopup.vue?vue&type=script&lang=js"

import "./sendToTeamsPopup.vue?vue&type=style&index=0&id=2852fb2b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2852fb2b"]])

export default __exports__